import React from 'react';
import Transition, { TransitionProps } from './Transition';

interface TranslateXTransitionProps extends TransitionProps {
  startOffset: number;
  endOffset: number;
}

const TranslateXTransition: React.StatelessComponent<
  TranslateXTransitionProps
> = ({ startOffset, endOffset, before, after, ...props }) => (
  <Transition
    property="transform"
    willChange="transform"
    before={createTransform(startOffset, before || {})}
    after={createTransform(endOffset, after || {})}
    {...props}
  />
);

TranslateXTransition.defaultProps = {
  startOffset: 0,
  endOffset: 0,
};

function createTransform(
  offset: number,
  style: { [key: string]: string | number }
) {
  if (offset === 0) {
    return style;
  }

  const transform = `translateX(${offset}px)`;

  return {
    ...style,
    transform,
    msTransform: transform,
    WebkitTransform: transform,
  };
}

export default TranslateXTransition;



// WEBPACK FOOTER //
// ./src/components/Transitions/TranslateXTransition.tsx